import React, { useCallback, useEffect, useState } from "react";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";

import { Link } from "react-router-dom";
import { OverlayTrigger, ProgressBar, Tooltip } from "react-bootstrap";
import { FiEye } from "react-icons/fi";

import BackBtn from "app/Components/CommanComponents/BackBtn";

import { useForm } from "app/_helpers/hooks";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import moment from "moment";
import { getOhseStatusClass, MEETING_STATUS, ohseFilterFields } from "./CONSTANT";
import { getAllOHSEHistory } from "app/_services/ehs/ehsEventScheduleServices";
import { DDMMYYYYHHMMAFormat, isBetween, YYYYMMDDFormat } from "app/_helpers/dateHelper";
import { formatDDMMYYYYbyYYYYMMDD } from "app/_helpers/helper";
import FilterBtn from "app/Components/CommanComponents/FilterBtn";
import OHSEFilter from "./Component/OHSEFilter";
import { validateRowFilter } from "../IncidentManagement/CONSTANTS";
import { ACTIVE_MODULE } from "app/_constants/constant";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";

function MyApprovalHistoryOHSE({
  match: {
    params: { siteId },
  },
}) {
  const [tab, setTab] = useState(0);
  const [incidents, setIncidents] = useState([]);
  const [incidentsFilter, setIncidentsFilter] = useState([]);
  const [tableOHSEList, setTableOHSEList] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filterForm, onChangeFilter, setFilterForm] = useForm({}, ohseFilterFields);
  // const [filterForm, onChangeFilter, setFilterForm] = useForm({});
  // const [showFilter, setShowFilter] = useState(true);

  // const onReset = useCallback(() => setFilterForm({}), [setFilterForm]);
  const onReset = () => setFilterForm({});

  const sortableColumn = [
    {
      dataField: "sid",
      text: "S.No.",
      sort: true,
    },
    {
      dataField: "scheduleId",
      text: "OHSE Review ID",
      sort: true,
      formatter: (scheduleId, row) => (
        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-top">View</Tooltip>}
        >
          <Link
            className="icons text-cyanBlue"
            to={
              (row?.eventStatus === MEETING_STATUS.draft ||
              row?.eventStatus === MEETING_STATUS.planned
                ? "/health-safety-and-environment/audits-meetings/scheduled-event/view/"
                : "/health-safety-and-environment/audits-meetings/scheduled-event/meeting/view/") +
              row?.id
            }
          >
            {scheduleId}
          </Link>
        </OverlayTrigger>
      ),
    },
    {
      dataField: "type",
      text: "Review Type",
      sort: true,
    },
    {
      dataField: "siteName",
      text: "Location",
      sort: true,
      //   formatter: (site) => `${site?.name}`,
    },
    {
      dataField: "venue",
      text: "Venue",
      sort: true,
    },
    {
      dataField: "date",
      text: "Review Date & Time",
      sort: true,
      formatter: (date) => DDMMYYYYHHMMAFormat(date),
    },
    {
      dataField: "progressStatus",
      text: "Progress",
      sort: true,
      formatter: (row, data) => {
        return (
          <>
            {data?.isExecuted == true ? (
              data?.progressCompleteTask !== 0 && data?.progressTotalTask !== 0 ? (
                <ProgressBar
                  className="progress mb-3 mt-2"
                  now={Number(data?.progressCompleteTask / data?.progressTotalTask) * 100}
                  striped
                  animated
                  label={`${
                    Number(data?.progressCompleteTask / data?.progressTotalTask) * 100
                  }%`}
                  variant="primary"
                ></ProgressBar>
              ) : (
                "N/A"
              )
            ) : (
              "N/A"
            )}
          </>
        );
      },
    },
    {
      dataField: "eventStatus",
      text: "Status",
      formatter: (status, row) => {
        return <div className={getOhseStatusClass(row?.eventStatus)}>{status}</div>;
      },
    },
    {
      dataField: "createdAt",
      text: "Time Stamp",
      sort: true,
      formatter: (createdAt, row) => {
        return DDMMYYYYHHMMAFormat(createdAt);
      },
    },
    {
      dataField: "id",
      text: "Action",
      formatter: (id, row) => {
        return (
          <div className="actionIconsGroup">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="tooltip-top">Views</Tooltip>}
            >
              <Link
                to={
                  (row?.eventStatus === MEETING_STATUS.draft ||
                  row?.eventStatus === MEETING_STATUS.planned
                    ? "/health-safety-and-environment/audits-meetings/scheduled-event/view/"
                    : "/health-safety-and-environment/audits-meetings/scheduled-event/meeting/view/") +
                  id
                }
                className="icons text-cyanBlue"
              >
                <FiEye />
              </Link>
            </OverlayTrigger>
          </div>
        );
      },
    },
  ];

  /**************** useEffect *************/
  useEffect(() => {
    // getAllOHSEHistory(siteId ? `filter[siteId]=${siteId}` : "").then((response) => {
    //   if (!response?.data) return;
    //   setIncidents(response.data);
    // });
    const fetchData = async () => {
      try {
        const response = await getAllOHSEHistory(
          siteId ? `filter[siteId]=${siteId}` : ""
        );
        if (!response?.data) {
          // Handle the case where data is not received
          setLoading(false);
          return;
        }
        setIncidents(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle error as needed, e.g., show an error message
        setLoading(false);
      }
    };
    fetchData();
  }, [siteId]);

  useEffect(() => {
    let data = [];
    if (tab === 1) {
      data = incidents?.schedular?.map((d, i) => ({ ...d, sid: i + 1 })) || [];
    }
    if (tab === 2) {
      data = incidents?.reviewer?.map((d, i) => ({ ...d, sid: i + 1 })) || [];
    }
    if (tab === 3) {
      data = incidents?.approver?.map((d, i) => ({ ...d, sid: i + 1 })) || [];
    }

    // let result = data.filter((row) => validateRowFilter(filterForm, row)).map((row) => ({ ...row, severity: CURRENT_SEVERITY(row) }));

    setIncidentsFilter(data);
  }, [incidents?.approver, incidents?.reviewer, incidents?.schedular, tab]);

  useEffect(() => {
    setTableOHSEList(
      incidentsFilter?.filter?.((data) => {
        let flag = true;
        if (filterForm?.startDate && filterForm?.endDate) {
          flag = isBetween(
            YYYYMMDDFormat(data.createdAt),
            YYYYMMDDFormat(filterForm.startDate),
            YYYYMMDDFormat(filterForm.endDate)
          );
        }

        if (flag) flag = validateRowFilter(filterForm, data);
        return flag;
      })
    );
  }, [filterForm, incidentsFilter]);

  useEffect(() => {
    setTab(
      incidents?.schedular?.length
        ? 1
        : incidents?.reviewer?.length
        ? 2
        : incidents?.approver?.length
        ? 3
        : 0
    );
  }, [
    incidents?.approver?.length,
    incidents?.reviewer?.length,
    incidents?.schedular?.length,
  ]);

  const tableToolbarBeforeView = () =>
    showFilter && (
      <OHSEFilter
        fields={ohseFilterFields}
        setForm={setFilterForm}
        form={filterForm}
        onChange={onChangeFilter}
        onReset={onReset}
      />
    );

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "OHSE Review",
            path: "/health-safety-and-environment/audits-meetings",
          },
          { name: "My Approval History" },
        ]}
        module={ACTIVE_MODULE.ohse}
      />
      <div className="card p-3">
        <div className="simple-card-title cardCustomHeader">
          <h3 class="text-capitalize mb-0">My Approval History</h3>
          <FilterBtn setShowFilter={setShowFilter} />
          {/* <button
          className="btn btn-outline-primary filterBtn"
          onClick={() => {
            setShowFilter((prev) => !prev);
          }}
        >
          <i className="i-Filter-2"></i>Filter
        </button> */}
          <BackBtn url={"/health-safety-and-environment/audits-meetings"} />
        </div>

        <div className="healthSafetyEnvironmentWrapper EHS_module_tabber">
          <div className="hseMenuLinks card">
            {incidents?.schedular?.length > 0 && (
              <a
                href
                onClick={() => setTab(1)}
                className={`pointer${tab === 1 ? " active" : ""}`}
              >
                Scheduler
              </a>
            )}

            {incidents?.reviewer?.length > 0 && (
              <a
                href
                onClick={() => setTab(2)}
                className={`pointer${tab === 2 ? " active" : ""}`}
              >
                Reviewer
              </a>
            )}
            {incidents?.approver?.length > 0 && (
              <a
                href
                onClick={() => setTab(3)}
                className={`pointer${tab === 3 ? " active" : ""}`}
              >
                Approver
              </a>
            )}
          </div>
        </div>
        {!loading ? (
          <SearchBootstrapTable
            searchKey={"myApprovalHistoryOHSEDesktop"}
            data={tableOHSEList}
            columns={sortableColumn}
            tableBeforeSearch={tableToolbarBeforeView}
            tableKey="myApprovalHistoryOHSE"
          />
        ) : (
          <NetZeroLoader />
        )}
      </div>
    </>
  );
}

export default MyApprovalHistoryOHSE;
